'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import { BASE_LINK_COLOR, BASE_LINK_HOVER_COLOR } from 'HubStyleTokens/theme';
import UILink from 'UIComponents/link/UILink';
import NestedNavItem from 'ecosystem-marketplace-core/components/nav/NestedNavItem';
const linkStyles = css(["color:", ";&:hover{color:", ";}"], BASE_LINK_COLOR, BASE_LINK_HOVER_COLOR);
const UnstyledNestedNavItemLink = styled(props => {
  const {
    _linkComponent: Link,
    className
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["_linkComponent", "className", "use"]);

  const itemClasses = classNames('unstyled-nested-nav-item', className);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, rest, {
    className: itemClasses
  }));
}).withConfig({
  displayName: "UnstyledNestedNavItem__UnstyledNestedNavItemLink",
  componentId: "q8ed79-0"
})(["&.unstyled-nested-nav-item{&&{font-size:inherit;", " &,&:hover{background-color:transparent;}}}"], props => props.use === 'link' ? linkStyles : '');
UnstyledNestedNavItemLink.propTypes = {
  _linkComponent: PropTypes.elementType,
  className: PropTypes.string,
  use: PropTypes.oneOf(['unstyled', 'link'])
};
UnstyledNestedNavItemLink.defaultProps = {
  _linkComponent: UILink,
  use: 'unstyled'
};

const UnstyledNestedNavItem = props => {
  return /*#__PURE__*/_jsx(NestedNavItem, Object.assign({}, props, {
    linkComponent: UnstyledNestedNavItemLink
  }));
};

export default UnstyledNestedNavItem;